import React, { useContext } from "react";
import { PublicRaceLaunchContext, PublicRaceLaunchContextValue } from './publicRaceLaunchPresentation';
import { usePublicRaceLaunchViewModel } from './usePublicRaceLaunchViewModel';

export const PublicRaceLaunchProvider = ({ children }: { children: React.ReactNode }) => {
  const { contextValue } = usePublicRaceLaunchViewModel();

  return (
    <PublicRaceLaunchContext.Provider value={contextValue}>
      {children}
    </PublicRaceLaunchContext.Provider>
  );
};

export const usePublicRaceLaunch = (): PublicRaceLaunchContextValue => {
  const context = useContext(PublicRaceLaunchContext);
  if (!context) {
    throw new Error("usePublicRaceLaunch must be used inside PublicRaceLaunchProvider");
  }
  return context;
};

export { type PublicRaceLaunchPhase } from './publicRaceLaunchPresentation';
